import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyAssetFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  const filteredRoisIds = Array.from(ctx.previousRoiIds).filter((id) => ctx.assetIndex.get(step.value)?.has(id));
  return new Set(filteredRoisIds);
}
